import React from 'react';
import * as XLSX from 'xlsx';
import axios from "axios";
import TooltipSimple from '../tooltips/TooltipSimple';
import { truncateString, setXlsxColumnFormat } from '../../../../utils.js';
import { useTranslation } from 'react-i18next';

let cancelToken;

export default function ButtonExcelDownload(props) {
    const {
        title,
        dataUrl,
        fromApi = false,
        params = {},
        columnsDef = false,
        disabled = false,
    } = props

    const { t: gctrad } = useTranslation();

    const downloadExcel = async e => {
        if (typeof cancelToken != typeof undefined) {
            cancelToken.cancel("Operation canceled due to new request.")
        }
        cancelToken = axios.CancelToken.source()

        let data = [];
        nav.wait({ display: true, 'delay': 100, 'text': 'export_stats_loader_text'.trad() });
        if (fromApi == true) {
            let loadMore = true;
            let next = null;
            do {
                let response = await fetchApiData(dataUrl, params, cancelToken, next);
                loadMore = response.loadMore;
                next = response.next;
                data = [...data, ...response.data];
            } while (loadMore);
        }
        else {
            const result = await axios.get(dataUrl, { cancelToken: cancelToken.token })
            data = result.data;
        }

        // Formatage des données avec des vrais en-têtes de colonnes qui ne viennent pas de l'API !
        if (columnsDef) {
            let exportCols = {};
            Object.entries(columnsDef).map(([id, item]) => {
                if (item.visibility) exportCols[id] = item.label;
                else exportCols[id] = false;
            });
            const getColumnPosition = (id) => Object.keys(exportData[0] ?? {}).indexOf(columnsDef[id].label);
            let exportData = [];
            var columnFormat = {
                date_with_hours: {},
                date_only: {},
                float: {},
                int: {}
            }
            data.map((row) => {
                let exportRow = {};
                Object.entries(exportCols).map(([id, item]) => {
                    if (item) {
                        if (columnsDef[id].autoTrad ?? false) {
                            row[id] = row[id].trad();
                        }
                        if ((columnsDef[id].format ?? false) == 'date' && row[id] != null) {
                            exportRow[item] = new Date(row[id]).toLocaleDateString(ENV.lang.replace('_', '-')) !== 'Invalid Date' ? new Date(row[id]) : '';
                            columnFormat.date_only[getColumnPosition(id)] = 'n';
                        }
                        else if ((columnsDef[id].format ?? false) == 'number' && row[id] != null) {
                            exportRow[item] = parseFloat(row[id]).toFixed(2);
                            columnFormat.float[getColumnPosition(id)] = 'n';
                        }
                        else {
                            exportRow[item] = row[id];
                        }
                    }
                });
                exportData.push(exportRow);
            });
            data = exportData;
        }
        nav.wait(false);

        const worksheet_title = truncateString((title.split('-').slice(-1).toString() ?? 'worksheet'), 31, '');
        const worksheet = XLSX.utils.json_to_sheet(data);
        if (columnsDef) {
            if (Object.keys(columnFormat.date_with_hours ?? {}).length) {
                setXlsxColumnFormat(worksheet, columnFormat.date_with_hours, getDateFormatString(true));  // date with hours
            }
            if (Object.keys(columnFormat.date_only ?? {}).length) {
                setXlsxColumnFormat(worksheet, columnFormat.date_only, getDateFormatString());  // date only
            }
            if (Object.keys(columnFormat.int ?? {}).length) {
                setXlsxColumnFormat(worksheet, columnFormat.int, '0');  // int
            }
            if (Object.keys(columnFormat.float).length ?? {}) {
                setXlsxColumnFormat(worksheet, columnFormat.float);  // float
            }
        }
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, worksheet_title);
        XLSX.writeFile(workbook, title + ".xlsx");
    }

    const fetchApiData = async (url, params, cancelToken, next) => {
        if (next) {
            url = ENV.api_backyou.url + next.replace('/api/', '');
        }
        const result = await axios.get(url, {
            params: params,
            headers: {
                "accept": "application/ld+json",
                "X-AUTH-TOKEN": ENV.api_backyou.key,
                "MUID": membres_uid,
                "SUID": societes_uid,
                "lang": ENV.lang
            },
            cancelToken: cancelToken.token
        });

        return {
            data: result.data['hydra:member'],
            loadMore: !!result.data['hydra:view'] && !!result.data['hydra:view']['hydra:next'],
            next: result.data['hydra:view'] && result.data['hydra:view']['hydra:next'] ? result.data['hydra:view']['hydra:next'] : null
        };
    }

    return (
        <>
            <TooltipSimple title={gctrad('Télécharger en format Excel _CSV_')}>
                <span>
                    <button
                        onClick={() => downloadExcel()}
                        className="btn btn-gc-light-blue-dark font-weight-bold"
                        disabled={disabled}
                    >
                        <i className="fa-regular fa-file-excel"></i>
                    </button>
                </span>
            </TooltipSimple>
        </>
    );
}